// Installed Packages Stylesheets
import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.css';

// SASS Local Stylesheet
import './src/styles/index.scss'